export default __webpack_public_path__ + "static/media/no-limit.b8deb4d2.svg";